export default function NotFound() {
    return (
      <div className="flex flex-col items-center justify-center h-screen text-center px-4">
        <h1 className="text-5xl md:text-5xl font-semibold">404</h1>
        <h1 className="text-2xl md:text-3xl font-semibold">Nothing Here</h1>
        <a className="text-2xl underline text-blue-600" href="/">Back to Home</a>
      </div>
    );
  }